import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSelect, MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'digi-select',
  templateUrl: './select.component.html',
  styleUrl: './select.component.scss',
})
export class SelectComponent {
  @Input() label: string = 'PLACEHOLDER.CHONMUC';
  @Input() options: any[] = [];
  @Input() labelKey: string = 'name';
  @Input() valueKey: string = 'id';
  @Input() control: FormControl = new FormControl([]);
  @Input() disabled: boolean = false;
  @Output() selectionChange = new EventEmitter<any>();
  @Output() loadMoreDate = new EventEmitter<any>();
  @Input() compareFn = (o1: any, o2: any) => {
    // Giả sử control.value là number, option[valueKey] cũng là number
    return o1 === o2;
  };
  @Input() enableSearch: boolean = false; // Bật/tắt ô tìm kiếm
  @Input() errorMessage: string = '';      // Thông báo lỗi nếu có
  @Input() isSubmit: boolean = false;

  @ViewChild('matSelect') matSelect!: MatSelect; // Truy xuất MatSelect

  searchText: string = '';
  filteredOptions: any[] = [];
  loading: boolean = false;

  ngOnInit() {
    this.filteredOptions = [...this.options];
    this.control.valueChanges.subscribe((value) => {
      this.selectionChange.emit(value);
    });
  }

  onSearchInput() {
    this.filterOptions();
    this.openDropdown(); // Mở dropdown khi nhập chữ
  }

  filterOptions() {
    if (this.enableSearch) {
      this.filteredOptions = this.options.filter(option =>
        option[this.labelKey]?.toLowerCase().includes(this.searchText.toLowerCase())
      );
    }
  }

  resetFilter(event: Event) {
    event.stopPropagation(); // Ngăn dropdown bị mở lại khi click vào icon
    this.searchText = '';
    this.filteredOptions = [...this.options];
    this.control.setValue(null);
    this.selectionChange.emit(null);
  }

  openDropdown() {
    if (this.matSelect) {
      this.matSelect.open(); // Mở dropdown
    }
  }

  hasValue(): boolean {
    return this.control.value !== null && this.control.value !== undefined && this.control.value !== '';
  }
  onLoadMore() {
    this.loadMoreDate.emit();
  }
}
